// extracted by mini-css-extract-plugin
export var active = "Navigation-module--active--37ZHY";
export var hamburger = "Navigation-module--hamburger--egX1X";
export var masterHead = "Navigation-module--masterHead--JWVL5";
export var navContain = "Navigation-module--navContain--2yjBI";
export var navFont = "Navigation-module--navFont--7rXjE";
export var navitem = "Navigation-module--navitem--9jEPF";
export var navlist = "Navigation-module--navlist--hpbgD";